import React from 'react';
import { makeStyles } from '@mui/styles';
import { Drawer, closeDrawer, useGlobalization } from '@innovyze/stylovyze';
import { useDispatch } from 'react-redux';
import { HELP_DRAWER, getHelpURL } from '@Utils/helpUrls';

export { HELP_DRAWER } from '@Utils/helpUrls';

const useStyles = makeStyles({
  drawer: {
    width: '34.5rem',
    zIndex: 1300,
    inset: 'unset',
  },
  iFrame: {
    height: 'calc(100% - 4px)',
    width: '100%',
  },
});

interface HelpDrawerProps {
  drawerID: HELP_DRAWER;
}

const HelpDrawer = ({ drawerID }: HelpDrawerProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useGlobalization();

  const close = () => {
    dispatch(closeDrawer());
  };

  return (
    <Drawer
      drawerId={drawerID}
      onClose={close}
      className={classes.drawer}
      hideBackdrop
      disableEnforceFocus
      padContent={false}
      action={{
        label: t('Close'),
        onClick: close,
      }}>
      <iframe
        src={getHelpURL(drawerID)}
        title="Help page"
        className={classes.iFrame}
      />
    </Drawer>
  );
};

export default HelpDrawer;
